export default __webpack_public_path__ + "static/media/02.590c42fe.png";